import React, { useState, createElement, Component } from 'react';
import { Link } from 'react-router-dom';
import { Download, MessageCircle, ArrowLeft, Check } from 'lucide-react';
import { Button } from '../components/ui/Button';
const WHATSAPP_URL = 'https://wa.me/447345197820';
// High-resolution QR (1000×1000), brand-coloured: deep green on warm ivory
const QR_SRC = `https://api.qrserver.com/v1/create-qr-code/?size=1000x1000&margin=16&color=2F4A3F&bgcolor=F8F5F0&data=${encodeURIComponent(WHATSAPP_URL)}`;
export function WhatsAppQrPage() {
  const [downloading, setDownloading] = useState(false);
  const [downloaded, setDownloaded] = useState(false);
  const handleDownload = async () => {
    setDownloading(true);
    try {
      const res = await fetch(QR_SRC);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'dentico-whatsapp-qr.png';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      setDownloaded(true);
      setTimeout(() => setDownloaded(false), 2500);
    } catch {
      // Fallback: open the image in a new tab so the user can save manually
      window.open(QR_SRC, '_blank', 'noopener,noreferrer');
    } finally {
      setDownloading(false);
    }
  };
  return <div className="min-h-screen w-full bg-ivory flex flex-col items-center justify-center px-4 py-12 print:bg-white" data-id="element-4666" data-mp="1s1k6rtfz8mwo">
      <div className="w-full max-w-md" data-id="element-4667" data-mp="2fsplg5a6l95e">
        {/* Back link (screen only) */}
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-charcoal-light hover:text-forest-700 transition-colors mb-8 print:hidden" data-id="element-4668" data-mp="2kowkde45tkdu">
          <ArrowLeft className="w-4 h-4" data-id="element-4669" data-mp="2aybqg3zfl419" />
          Back to site
        </Link>

        {/* Card */}
        <div className="bg-ivory-200 rounded-3xl border border-beige/60 shadow-sm overflow-hidden" data-id="element-4670" data-mp="2ynwbqtj24ddp">
          {/* Header */}
          <div className="bg-forest-600 px-8 py-7 text-center" data-id="element-4671" data-mp="33i0ipcsboles">
            <span className="block text-xl font-semibold tracking-[0.22em] text-white" style={{
            fontFamily: '"Playfair Display", Georgia, serif'
          }} data-id="element-4672" data-mp="3dbnwamny9ys3">
              DENTICO
            </span>
            <span className="block text-[10px] tracking-[0.4em] text-beige uppercase mt-1" data-id="element-4673" data-mp="2zcxyt5x7xx37">
              Clinic
            </span>
          </div>

          {/* QR */}
          <div className="px-8 pt-8 pb-2 flex flex-col items-center" data-id="element-4674" data-mp="2uf4vqlr7pj75">
            <div className="bg-ivory rounded-2xl border border-beige/60 p-5 shadow-sm" data-id="element-4675" data-mp="2pl0oe1e1b95j">
              <img src={QR_SRC} alt="Scan to book via WhatsApp with Dentico Clinic" className="w-56 h-56 sm:w-64 sm:h-64 object-contain" width={1000} height={1000} data-id="element-4676" data-mp="2koa9hhdyujlp" />
            </div>

            <div className="mt-6 flex items-center gap-2 text-forest-700" data-id="element-4677" data-mp="26nhbunsdb8ed">
              <MessageCircle className="w-5 h-5" strokeWidth={1.75} data-id="element-4678" data-mp="m5yoa60gzg2y" />
              <span className="text-base font-semibold" data-id="element-4679" data-mp="m7szgslxvttu">Book on WhatsApp</span>
            </div>
            <p className="mt-2 text-sm text-charcoal-light text-center leading-relaxed" data-id="element-4680" data-mp="r2ym5tn61ciz">
              Scan with your phone camera to message us and book your
              appointment instantly.
            </p>
          </div>

          {/* Actions (screen only) */}
          <div className="px-8 pt-6 pb-8 space-y-3 print:hidden" data-id="element-4681" data-mp="3g8m2xudns10">
            <Button onClick={handleDownload} isLoading={downloading} fullWidth size="lg" className="gap-2" data-id="element-4682" data-mp="7gixwr4upcns">
              {downloaded ? <>
                  <Check className="w-5 h-5" data-id="element-4683" data-mp="h86m8j642dl1" />
                  Saved
                </> : <>
                  <Download className="w-5 h-5" data-id="element-4684" data-mp="3furl1joltb8k" />
                  Save QR Code
                </>}
            </Button>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="block" data-id="element-4685" data-mp="1rcgaz6ytphix">
              <Button variant="whatsapp" fullWidth size="lg" className="gap-2" data-id="element-4686" data-mp="1mc259vkp2jo2">
                <MessageCircle className="w-5 h-5" data-id="element-4687" data-mp="206l0nn280mwv" />
                Open WhatsApp
              </Button>
            </a>
          </div>
        </div>

        {/* Caption */}
        <p className="mt-6 text-center text-xs text-stone-500 print:hidden" data-id="element-4688" data-mp="2a267pzm5cddh">
          Saves as a high-resolution PNG, ready for print or sharing.
        </p>
      </div>
    </div>;
}